import React from 'react';
import BaseComponent from './BaseContainer';
import { graphql, compose, withApollo } from 'react-apollo';
import PracticalInfoForm from '../components/form/PracticalInfo';
import getPracticalInfo from '../apollo/graphql/practicalInfo/get';
import updatePracticalInfo from '../apollo/graphql/practicalInfo/update';
import {
  convertGraphQlToObject,
  convertObjetToGraphQlVariables,
} from '../helpers/contentWithI18n';
import { languages } from '../constants';
import { createTranslationsObject } from '../helpers/translation';

class PracticalInfoContainer extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      status: {
        loading: true,
        message: null,
        error: null,
      },
      redirect: false,
      obj: {
        tt_all_days: 0,
        tt_hours: null,
        translations: createTranslationsObject({
          title: '',
          opening: '',
          closing_time: '',
          push_cta_label: '',
          push_cta_url: '',
          section_instagram_title: '',
          meta_title: '',
          meta_description: '',
          meta_tags: '',
          meta_og_title: '',
          meta_og_description: '',
          meta_og_url: '',
        }),
      },
      languages: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    this.props.client
      .query({
        query: getPracticalInfo,
      })
      .then(({ data }) => {
        if (getPracticalInfo.error) {
          this.setState({
            status: {
              ...this.state.status,
              error: true,
              message: getPracticalInfo.error.message,
            },
          });
        }

        const newObject = {
          ...this.state.obj,
          ...convertGraphQlToObject(data.getPracticalInfo),
        };
        this.setState({
          ...this.state,
          status: {
            ...this.state.status,
            loading: false,
          },
          obj: {
            ...this.state.obj,
            ...newObject,
            translations: {
              ...this.state.obj.translations,
              ...newObject.translations,
            },
          },
        });
      });
  }

  handleChange(event, data, type) {
    let newState = {
      obj: {
        ...this.state.obj,
      },
    };
    let dataIsLanguage = false;
    for (let att of languages) {
      if (att.code === data) {
        dataIsLanguage = true;
      }
    }
    if (dataIsLanguage) {
      //translations data
      newState.obj.translations[data][event.target.id] = event.target.value;
    } else if (typeof data === 'object' && data.id.indexOf('tt_hours') !== -1) {
      const keys = data.id.match(/(\w+)/g);
      if (keys !== null && keys.length === 3) {
        if (!newState.obj['tt_hours']) {
          newState.obj['tt_hours'] = {};
        }
        if (!newState.obj['tt_hours'][keys[1]]) {
          newState.obj['tt_hours'][keys[1]] = {};
        }
        newState.obj['tt_hours'][keys[1]][keys[2]] = data.value;
      }
    } else if (type === 'dropdown') {
      //dropdown
      newState.obj[data.id] = data.value;
    } else if (event.target.files && event.target.files.length > 0) {
      //files
      newState.obj[event.target.id] = event.target.files[0];
    } else {
      //simple data
      newState.obj[event.target.id] = event.target.value;
    }
    this.setState(newState);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      status: {
        ...this.state.status,
        loading: true,
      },
    });
    const obj = convertObjetToGraphQlVariables(this.state.obj);

    let newObj = {
      ...obj,
    };
    this.props
      .updatePracticalInfo({
        variables: {
          input: {
            ...newObj,
          },
        },
      })
      .then(({ data, errors }) => {
        if (errors) {
          this.setState({
            status: {
              ...this.state.status,
              loading: false,
              errors: errors,
            },
          });
        } else {
          this.setState({
            status: {
              ...this.state.status,
              loading: false,
              messages: [{ message: 'Sauvegarde effectuée' }],
            },
          });
        }
      });
  }

  render() {
    if (this.state.status.loading) {
      return <div>Chargement</div>;
    }
    return (
      <PracticalInfoForm
        obj={this.state.obj}
        status={this.state.status}
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

const PracticalInfoContainerEnhanced = compose(
  graphql(updatePracticalInfo, { name: 'updatePracticalInfo' }),
)(PracticalInfoContainer);

export default withApollo(PracticalInfoContainerEnhanced);



// WEBPACK FOOTER //
// ./src/containers/PracticalInfoContainer.js